import React from "react";

const AyanshtechAdvantage = () => {
  return (
    <div>
      <div className="text-center mb-2 mt-6 p-4 ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Why Choose Ayanshtech
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
          Partnering with Ayanshtech gives you access to certified developers on
          hourly, part-time, or full-time contracts. Tailor your team to fit
          your needs and project goals.
        </p>
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-7xl mx-auto p-4">
        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\AyanshtechAdvantage\icon1.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Access to a diverse pool of skilled developers and industry tools
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\AyanshtechAdvantage\icon2.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Collaborate with top-tier industry experts and developers
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\AyanshtechAdvantage\icon3.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Focus on quality with agile development practices
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\AyanshtechAdvantage\icon4.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Flexible hiring options that allow you to hire developers as
              needed
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\AyanshtechAdvantage\icon5.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Pay for dedicated developers only when they work on your project
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <img
            src="\assets\icons\AyanshtechAdvantage\icon6.png"
            alt="icon"
            className="w-10 h-10"
          />
          <div>
            <p className="text-lg">
              Dedicated developers focus solely on your project needs
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AyanshtechAdvantage;
